const _defaultExport = new String(".position-text-wrapper{font-size:.875rem;padding-bottom:48px;line-height:1.32;ul {\n      li {\n        line-height: 24px;\n        padding-left: 32px;\n      }\n    }\n  }");
_defaultExport.__hash = "2465f3b35887b06e";
export default _defaultExport;
